module.exports = __webpack_public_path__ + "img/arrow-redo-outline.0a96b825.svg";